import { ICycle, IResponseCyclesCode } from 'v2/resources/types/cycles';

export const DEFAULT_RESPONSE_CYCLES: Array<ICycle> = [
  {
    id: 0,
    code: 0,
    begin: '',
    end: '',
    ponds: [
      {
        begin: '',
        end: '',
        id: 0,
        status: '',
        description: '',
        growingDays: 0,
        specie_category: '',
        system: '',
        totalFoodOffered: 0,
        type: '',
        usedFeed: 0,
      },
    ],
  },
];

export const DEFAULT_RESPONSE_CYCLES_CODE: Array<IResponseCyclesCode> = [
  {
    id: 0,
    created_at: '',
    updated_at: '',
    deleted_at: null,
    year: 0,
    cod: 0,
    start: '',
    end: '',
    production: '',
    specie_category: '',
  },
];
